import { ButtonPrimary } from 'components/Button'
import { Dots } from 'pages/Islands/styleds'
import React, { useContext } from 'react'
import { Text } from 'rebass'
import { ThemeContext } from 'styled-components'
import { ThemedText } from 'theme'

import { EarnedItemType } from '../../context/RewardContext'
import { InnerCardFlex, IslandCardFlex } from '../../styleds'
import VaultClaimModal from '../modals/VaultClaimModal'
import EarnedTokenRow from './EarnedTokenRow'

interface RewardsCardProps {
  earnedItems: EarnedItemType[]
  hasEarnings: boolean
  buttonText: string
  anyTransactionInProgress: boolean
  txError: string
  onClaimClick: () => void
}

const RewardsCard: React.FC<RewardsCardProps> = ({
  earnedItems,
  hasEarnings,
  buttonText,
  anyTransactionInProgress,
  txError,
  onClaimClick,
}) => {
  const theme = useContext(ThemeContext)

  return (
    <>
      <IslandCardFlex>
        <ThemedText.DeprecatedBody fontSize="14px" fontWeight="400" lineHeight="14px" color={theme.textPrimary}>
          Earned
        </ThemedText.DeprecatedBody>

        {earnedItems.map((item: EarnedItemType, index: number) => (
          <InnerCardFlex key={index}>
            <EarnedTokenRow key={`${index}-${item.token?.address}`} item={item} />
          </InnerCardFlex>
        ))}

        <ButtonPrimary onClick={onClaimClick} disabled={anyTransactionInProgress || !hasEarnings}>
          <Text fontSize={18} fontWeight={500}>
            {buttonText}
            {anyTransactionInProgress && <Dots />}
          </Text>
        </ButtonPrimary>
      </IslandCardFlex>
      <VaultClaimModal />
    </>
  )
}

export default RewardsCard
